import { Component, OnInit, OnChanges, Input, Output, EventEmitter, SimpleChanges, AfterContentInit, Inject, PLATFORM_ID, Renderer2 } from '@angular/core';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
// store
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
// services
import { FlightDetailsService } from '../../services/flight-details.service';
import { AppLoaderService } from '../../services/app-loader.service';
import { ErrorHandler } from '../../../shared/services/error-handler.service';
import { CopyService } from '../../../shared/services/app-copy.service';
import { AirportCopyService } from '../../../shared/services/app-airport-copy.service';
import { ExternalScriptsService } from '../../../shared/services/external-scripts.service';

// models
import { AppState } from '../../../booking/models/app-state.interface';
import { FlightFinderInitState } from '../../../shared/models/flight-finder.interface';
import { ModalData } from '../../../shared/models/modal.interface';
import { take } from 'rxjs/operators';
import { DataStorageService } from '../../../shared/services/data-storage.service';
import { SLOT_NUMBER } from '../../globals';
import { SharedService } from '../../services/shared-service.service';
import { environment } from '../../../../environments/environment';

declare var ga: any;
declare var exponea: any;

@Component({
  selector: 'app-flight-results',
  templateUrl: './flight-results.component.html',
  styleUrls: ['./flight-results.component.scss']
})
export class FlightResultsComponent implements OnInit, OnChanges, AfterContentInit {

  @Input()
  fullAirportsList: any;

  @Input()
  firstLoad: boolean;

  @Input()
  dataLoaded: boolean;

  @Input()
  flightResults: any;

  @Input()
  flightData: any;

  @Output()
  selectFlight: EventEmitter<any> = new EventEmitter;

  @Output()
  searchFlight: EventEmitter<any> = new EventEmitter;

  @Output()
  searchNonDirect: EventEmitter<any> = new EventEmitter;

  @Output()
  flightNumberFilter: EventEmitter<any> = new EventEmitter;

  @Output()
  cancelFlightRequest: EventEmitter<any> = new EventEmitter;

  private _flightStoreData: Subscription;
  private _copyInitSubscription: Subscription;
  private _userLanguageSubscription: Subscription;
  private _currentBookingSubscription: Subscription;
  private _BookingReducerSubscription: Subscription;

  public flightSelectionDisabled = false;
  public flightLeg = {
    direct: true,
    oneStop: false,
    twoStop: false
  };
  public direction = null;
  public flightNumber = { value: null };
  public flightLoading = false;
  public filteredCombinedFlights = null;
  public selectedFlight = null;
  public legsFilter = '0';
  public activeRadioIndex = 0;
  public userSelectedLegValue = 0;
  public selectedFlightId = null;
  public quoteFlightNumber = null;
  public appCopy;
  public appAirportCopy;
  public copyLoaded: Boolean = false;
  public airportCopyLoaded: Boolean = false;
  public selectedLanguage = '';
  public languageCode = '';
  public bookingType: string;
  public currentBooking;
  public flightSearchString: string;
  public initialFlightSearchString: string;
  public returnCustomerUrl: string;
  public revealMaxHeight = '1000px';

  constructor(
    private _renderer: Renderer2,
    private _appStore: Store<AppState>,
    private _flightDetailsService: FlightDetailsService,
    private _appLoaderService: AppLoaderService,
    private _copyService: CopyService,
    private _sharedService: SharedService,
    private _airportCopyService: AirportCopyService,
    private _dataStorageService: DataStorageService,
    private _externalScriptsService: ExternalScriptsService,
    private _errorService: ErrorHandler,
    @Inject(PLATFORM_ID) private platformId: Object,
    private _router: Router,
    private _route: ActivatedRoute,

  ) { }
  ngAfterContentInit(): void {
    if (this.quoteFlightNumber) {
      for (let item = 0; item < this.flightResults.length; item++) {
        if (this.quoteFlightNumber === this.flightResults[item].flightInfo.requestFlightNumber) {
          this.toggleSelectedItem(null, this.flightResults[item].flightInfo)
        }
      }
    }
  }

  cancelAmend() {
    this._router.navigate(['my-account/bookings/booking-details'],
      { queryParams: { ref: this.currentBooking.bookingReference } });
  }

  ngOnInit() {
    console.log("flightData", this.flightData);
    if (isPlatformBrowser(this.platformId)) {
      const control_group = this._route.snapshot.queryParamMap.get('control_group');
      const exponeaAttributes: any = {
        'A/B Test': this._sharedService.getCurrentSlotNumber(),
        entry_source: this.getState(this._appStore).d2dReducer.entrySource || 'direct',
      };

      if (control_group) { exponeaAttributes.control_group = control_group; }
      exponea.track('flight_selection_load', exponeaAttributes);
    }

    this._BookingReducerSubscription = this._appStore.select('bookingReducer')
      .subscribe((res: any) => {
        this.bookingType = res.bookingDetails.bookingType;
      });

    this._currentBookingSubscription = this._appStore.select('currentBookingReducer')
      .subscribe((res: any) => {
        this.currentBooking = res.currentBooking;

      });
    // will work without reloading
    this._copyInitSubscription = this._appStore.select('loadedStatusReducer')
      .subscribe((res: any) => {
        // if booking data has bookingLoaded
        // show template and subscribe to data

        this.copyLoaded = res.copyLoaded;
        this.airportCopyLoaded = res.airportCopyLoaded;

        if (res.copyLoaded && res.airportCopyLoaded) {
          if (isPlatformBrowser(this.platformId)) {
            this.getCopy();
          }
          this.getAirportCopy();
        }
        this._userLanguageSubscription = this._appStore.select('copyReducer')
          .subscribe((res: any) => {
            this.selectedLanguage = res.language
            this.languageCode = res.languageCode
          })

      });

    this.dataLoaded = false;
    this.checkAirportNamesHaveCode();

    this._flightStoreData = this._appStore.select('flightFinderReducer')
      .subscribe((res: FlightFinderInitState) => {

        if (res.requestCount === 0) {
          this.quoteFlightNumber = res.quoteFlightRequest.flightNumber;
          this.flightLeg = res.filterLegs;
          this.activeRadioIndex = this.userSelectedLegValue > 0 ? this.userSelectedLegValue : Object.keys(this.flightLeg).map(key => this.flightLeg[key]).findIndex(item => item === true);
          this.legsFilter = this.activeRadioIndex.toString();
          this.flightSelectionDisabled = res.userHasSelected;

          if (this.flightSelectionDisabled) {
            this.dataLoaded = false;
          } else {
            this.dataLoaded = true;
            this._appLoaderService.hideLoader();
          }

          if (this.direction === null) {
            this.direction = this._flightDetailsService.checkDirection(this.flightData.originAirportCode);
          }
          this.flightSearchString = res.airlineSearchString;
          this.initialFlightSearchString = res.airlineSearchString;
          this.returnCustomerUrl = res.returnCustomerUrl;
        }
      });

    this._router.navigate([], { relativeTo: this._route, queryParamsHandling: 'merge', queryParams: { 'start-booking': true, 'amendResults': true } })
  }

  // get store state
  getState(store: Store<AppState>): AppState {
    let state: AppState;
    store.pipe(take(1))
      .subscribe(s => state = s);
    return state;
  }

  getCopy() {
    const panelHeaderCopy = this._copyService.getCopyBySection(
      'OTHER',
      'results',
      ['panelHeader']
    );

    this.appCopy = {
      panelHeader: panelHeaderCopy[0],
    };

  }

  getAirportCopy() {
    this.appAirportCopy = this._airportCopyService.getAirportsCopy();
  }

  ngOnChanges(changes: SimpleChanges) {
    this._appLoaderService.hideLoader();
    if (typeof changes.flightResults !== 'undefined') {
      if (changes.flightResults.currentValue.length === 1) {
        this.toggleSelectedItem(null, changes.flightResults.currentValue[0].flightInfo.id);
      }
    }
  }

  checkAirportNamesHaveCode() {
    if (!this.flightData.destinationAirportName.includes('(') && !this.flightData.destinationAirportName.includes(')')) {
      this.flightData.destinationAirportName = this.flightData.destinationAirportName + ' (' + this.flightData.destinationAirportCode + ')';
    }
    if (!this.flightData.originAirportName.includes('(') && !this.flightData.originAirportName.includes(')')) {
      this.flightData.originAirportName = this.flightData.originAirportName + ' (' + this.flightData.originAirportCode + ')';
    }
  }

  searchByFlightNumber(value) {
    if (value === null || value === '') { return; }
    // this.selectFlight.emit({flight: { flightNumberSearch: true, flightNumber: event.target.value }});
    // call api to get filtered flight connections
    this.searchFlight.emit(value)
  }

  clearFlightSearch() {
    this.searchFlight.emit('clear');
  }

  toggleSelectedItem(event, flightInfo) {
    const _id = flightInfo.id
    if (this.selectedFlightId !== _id) {
      this.selectedFlightId = _id;
    } else {
      this.selectedFlightId = null;
    }
    ga('send', 'event', 'Vanilla', 'Result - Flight', flightInfo.requestFlightNumber);
  }

  handleCancelFlight() {
    this.selectedFlightId = null;
  }

  handleConfirmFlight(data) {
    this.selectFlight.emit(data);
  }

  filterLegChanged(event, modelItem) {
    this.flightLeg = {
      direct: false,
      oneStop: false,
      twoStop: false
    };
    this.flightLeg[modelItem] = true;

    this._appLoaderService.showLoader();
    this.activeRadioIndex = parseInt(event, 10);
    this.userSelectedLegValue = this.activeRadioIndex;
    this.selectedFlightId = null;
    this.searchNonDirect.emit(this.flightLeg);
    ga('send', 'event', 'Vanilla', 'Result - Legs', event);
  }

  // change
  toggleSearchModal() {
    if (this.returnCustomerUrl === '') {
      const modalData: ModalData = {
        type: 'default',
        modalType: 'flightSearch',
        title: this.appCopy.panelHeader['EditFlightTitle' + this.selectedLanguage],
        content: '',
        buttonText: '',
        cancelButtonText: this.appCopy.panelHeader['linkCancel' + this.selectedLanguage],
        showLoader: true,
      };
      // this._errorService.handleModal(modalData);
      window.location.replace(environment.homeURL);
    } else {
      window.location.replace(this.returnCustomerUrl);
    }

  }

  showLinkedFlights(e, flightData) {
    e.stopPropagation();

    const modalData: ModalData = {
      type: 'default',
      modalType: 'associatedFlight',
      title: this.appCopy.panelHeader['associatedFlightTitle' + this.selectedLanguage],
      cancelButtonText: this.appCopy.panelHeader['flightModalCloseBtn' + this.selectedLanguage],
      copyData: {
        airline: this.appCopy.panelHeader['airline' + this.selectedLanguage],
        flightNumber: this.appCopy.panelHeader['flightNumber' + this.selectedLanguage]
      },
      image: '',
      buttonText: '',
      showLoader: false,
      flightData: flightData,
    };
    this._errorService.handleModal(modalData);
  }

  redirectToSearch() {
    if (this.returnCustomerUrl === '') {
      this._appStore.dispatch({ type: 'UPDATE_REDIRECT_TO_SEARCH', payload: true });
      window.location.replace(environment.homeURL);
      // this._router.navigate(['flight-finder/search'], {queryParams: {'start-booking': true}});
    } else {
      window.location.replace(this.returnCustomerUrl);
    }
  }


  ngOnDestroy() {
    this._copyInitSubscription.unsubscribe();
    this._currentBookingSubscription.unsubscribe();
    this._BookingReducerSubscription.unsubscribe();
    if (this._userLanguageSubscription) { this._userLanguageSubscription.unsubscribe(); }
    if (this._flightStoreData) { this._flightStoreData.unsubscribe(); }

    // Remove the modal on destroy
    this._errorService.modalItem$.next("remove");
    if (isPlatformBrowser(this.platformId)) {
      this._externalScriptsService.removeScript('portr-booking-pod');
      this._externalScriptsService.removeScript('pod-global-fns');
      this._externalScriptsService.podUiCleanup('bookingPod');
      this._renderer.setStyle(document.body, 'position', 'sticky');
    }
  }

}
